import React from 'react';
import { Footer } from '../components';

export function FooterContainer() {
  return (
    <Footer>
      <Footer.Row>
        <Footer.Column>
          <Footer.Logo
            src="https://help.vieon.vn/server/public/images/web-content/logo-main-1749007077.jpg"
            alt="VieON"
          />
          {/* <Footer.BadgeContainer>
            <Footer.Badge src="https://static2.vieon.vn/prod-vieon-web-v5-gcp/_next/assets/img/sprites/logo-mit.svg" alt="Đã thẩm định" />
            <Footer.Badge src="https://images.dmca.com/Badges/dmca_protected_sml_120m.png?ID=598b9d29-b519-4000-b70c-4c1f1dfdc677" alt="DMCA Protected" />
            <Footer.Badge src="https://static2.vieon.vn/prod-vieon-web-v5-gcp/_next/assets/img/pci-dss-compliant-logo-vector.svg" alt="PCI DSS Compliant" />
          </Footer.BadgeContainer> */}
        </Footer.Column>

        <Footer.Column>
          <Footer.ColumnTitle>GIỚI THIỆU</Footer.ColumnTitle>
          <Footer.Link href="#">Giới Thiệu Về VieON</Footer.Link>
        </Footer.Column>

        <Footer.Column>
          <Footer.ColumnTitle>QUY ĐỊNH</Footer.ColumnTitle>
          <Footer.Link href="#">Hợp Đồng Điện Tử</Footer.Link>
          <Footer.Link href="#">Điều Khoản Và Điều Kiện</Footer.Link>
          <Footer.Link href="#">Chính Sách Bảo Vệ Thông Tin Cá Nhân</Footer.Link>
        </Footer.Column>

        <Footer.Column>
          <Footer.ColumnTitle>THÔNG TIN</Footer.ColumnTitle>
          <Footer.Link href="#">Thông Báo</Footer.Link>
          <Footer.Link href="#">Trung Tâm Hỗ Trợ</Footer.Link>
          <Footer.Link href="#">Liên Hệ</Footer.Link>
          <Footer.Link href="#">Góp Ý</Footer.Link>
        </Footer.Column>
      </Footer.Row>

      <Footer.Row>
        <Footer.WideColumn>
          <Footer.InfoSection>
            <p>Công ty Cổ phần VieON - Địa chỉ: Tầng 5, 222 Pasteur, Phường Xuân Hòa, Thành phố Hồ Chí Minh.</p>
            <p>Email: support@vieon.vn | Hotline: 1800.599.920 (miễn phí)</p>
            <p>Giấy phép Cung cấp Dịch vụ Phát thanh, Truyền hình trả tiền số 247/GP-BTTTT cấp ngày 21/07/2023.</p>
            <p>
              Giấy Chứng Nhận Đăng Ký Doanh Nghiệp số: 0314415573 do Sở Kế Hoạch Đầu Tư Thành Phố Hồ Chí Minh cấp ngày
              19/05/2017
            </p>
            <p>
              Giấy Chứng Nhận Đăng Ký Kết Nối Để Cung Cấp Dịch Vụ Nội Dung Thông Tin Trên Mạng Viễn Thông Di Động số
              284/GCN-CYT do Cục Viễn Thông cấp ngày 13/06/2025
            </p>
          </Footer.InfoSection>
        </Footer.WideColumn>

        <Footer.WideColumn>
          <Footer.QRSection>
            <Footer.Text style={{ marginBottom: '10px', fontSize: '12px' }}>Quét mã QR để tải ứng dụng</Footer.Text>
            <Footer.QRCode
              src="https://static2.vieon.vn/vieon-images/2022-web/navigation/QRCodeDownApp.png"
              alt="QR Code"
            />
            <Footer.AppButtons>
              <Footer.AppButton
                src="https://static2.vieon.vn/prod-vieon-web-v5-gcp/_next/assets/img/sprites/Download-Appstore.svg"
                alt="Download on App Store"
              />
              <Footer.AppButton
                src="https://static2.vieon.vn/prod-vieon-web-v5-gcp/_next/assets/img/sprites/download-googleplay.svg"
                alt="Get it on Google Play"
              />
            </Footer.AppButtons>
          </Footer.QRSection>
        </Footer.WideColumn>
      </Footer.Row>
    </Footer>
  );
}
